import { render } from "./GoogleLogin.vue?vue&type=template&id=031ff235"
import script from "./GoogleLogin.vue?vue&type=script&lang=js"
export * from "./GoogleLogin.vue?vue&type=script&lang=js"
script.render = render

export default script